import { useRef, useState } from "react";

export function useReplaySeek(proctor) {
  const [seek, setSeek] = useState({ idx: 0, nonce: 0 });
  const [seekNotice, setSeekNotice] = useState("");
  const replayRef = useRef(null);
  const cameraRef = useRef(null);
  const screenRef = useRef(null);
  const target = (flag) => {
    const frames = proctor?.snapshots || [];
    const time = Date.parse(flag.at);
    let idx = frames.findIndex((f) => flag.snapshot_path && f.path === flag.snapshot_path);
    if (idx < 0 && Number.isFinite(time)) {
      let distance = Infinity;
      frames.forEach((f, i) => { const d = Math.abs(Date.parse(f.at) - time); if (d < distance) {distance = d; idx = i;} });
      if (distance > 15000) idx = -1;
    }
    const videos = [[proctor?.recording,cameraRef], [proctor?.screen_recording,screenRef]].flatMap(([rec,ref]) => {
      if (!rec?.path || !rec.started_at || !Number.isFinite(time)) return [];
      const seconds = (time-Date.parse(rec.started_at))/1000;
      return seconds >= 0 && seconds <= (rec.duration_seconds ?? Infinity) ? [{ref,seconds}] : [];
    });
    return {idx,videos};
  };
  const canSeek = (flag) => { const t=target(flag); return t.idx>=0 || t.videos.length>0; };
  const jump = (flag) => {
    const {idx,videos} = target(flag);
    videos.forEach(({ref,seconds}) => {
      const v=ref.current;
      if (!v) return;
      const seekVideo = () => { v.pause(); v.currentTime=Number.isFinite(v.duration) ? Math.min(seconds,v.duration) : seconds; };
      if (v.readyState>=1) seekVideo(); else v.addEventListener('loadedmetadata',seekVideo,{once:true});
    });
    if (idx>=0) setSeek((s)=>({idx,nonce:s.nonce+1}));
    const el = videos[0]?.ref.current || replayRef.current;
    el?.scrollIntoView({behavior:'smooth',block:'nearest'});
    setSeekNotice(videos.length ? `Paused at ${videos[0].seconds.toFixed(1)}s — ${flag.label || flag.type.replaceAll('_',' ')}` : idx>=0 ? 'Showing the nearest available snapshot. This is a sampled frame, not exact video.' : 'No recording or nearby snapshot covers this flag.');
  };
  return {seek,replayRef,cameraRef,screenRef,seekNotice,jump,canSeek};
}
